import { CircularProgress } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import {
  DownloadButtonProps,
  DownloadCaseButton,
} from '../../common/components/DownloadCaseButton';

export const InlineTableButton = styled.button`
  width: 100px;
  padding: 4px 8px;
  background-color: var(--HScan_Light_Blue, #2e5be0);
  color: #ffffff;
  border: 0;
  border-radius: 19px;
  cursor: pointer;
`;

interface DownloadSingleCaseButtonProps {
  caseId: string;
}
export const DownloadSingleCaseButton = ({
  caseId,
}: DownloadSingleCaseButtonProps) => {
  return (
    <DownloadCaseButton
      caseIds={[caseId]}
      DownloadButton={DownloadSingleCaseButtonContent}
    />
  );
};

const DownloadSingleCaseButtonContent = ({
  isDownloading,
  onClick,
}: DownloadButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.downloadButton',
  });

  return (
    <InlineTableButton onClick={isDownloading ? undefined : onClick}>
      {isDownloading ? (
        <CircularProgress size={16} style={{ color: 'white' }} />
      ) : (
        t('label')
      )}
    </InlineTableButton>
  );
};
